import React from 'react'
import {
    GoogleMap,
    useLoadScript,Marker
  } from "@react-google-maps/api";
  const libraries= ["places"]
function MapContainer({lat, lng}) {
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: "AIzaSyAkcs8Ts4pbqDXqkc8RY4Xgx73gSgHNF5w",
        libraries
      });
     if(loadError) return "error"
     if(!isLoaded) return "loading map"
    return (
        <div>
            <GoogleMap
                mapContainerStyle={{width:"100%",height:"22rem"}}
                zoom={17}
                center={{lat:lat,lng:lng}}
            >
            <Marker position={{lat:lat,lng:lng}}/>
            </GoogleMap>
        </div>
    )
}

export default MapContainer
